import React from 'react'
import ReactMarkdown from 'react-markdown'
import { injectIntl, intlShape } from 'react-intl'

import './ContentBlocks.css'

const ContentBlock = (props) => (
  <div className={props.align.toLowerCase()}>    
    {props.fields.topHeading && <div className="subheading">{props.fields.topHeading}</div>}
    {(props.fields.heading && props.fields.align.toLowerCase()==='center') && <h2>{props.fields.heading}</h2>}
    {(props.fields.heading && props.fields.align.toLowerCase()!=='center') && <h3>{props.fields.heading}</h3>}

    {props.fields.lead && <div className="lead">
      <ReactMarkdown source={props.fields.lead} softBreak="br" />
    </div>}

    {props.fields.content && <div className="content">
      <ReactMarkdown source={props.fields.content} softBreak="br" />
    </div>}

    {(props.fields.leadLinkText && (props.fields.leadInternalLink || props.fields.leadLinkUrl)) && <a href={props.fields.leadInternalLink ? props.fields.leadInternalLink.fields.slug : props.fields.leadLinkUrl} className="btn">{props.fields.leadLinkText}</a>}
  </div>
)

ContentBlock.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(ContentBlock)



// WEBPACK FOOTER //
// ./src/components/ContentBlocks/ContentBlock.js